import React from 'react';
import { ThemedAssessmentStepIndicator } from '../themed/ThemedAssessmentStepIndicator';

export const AssessmentStepIndicator = ({
    isCurrent,
    isActive,
    primaryColor,
}) => {
    if (isCurrent) {
        return (
            // A large themed circle is used for the current step
            <ThemedAssessmentStepIndicator
                primaryColor={primaryColor}
                isCurrent
                isActive
            />
        );
    } else if (isActive) {
        return (
            // A small themed circle is used for completed steps
            <ThemedAssessmentStepIndicator
                primaryColor={primaryColor}
                isActive
            />
        );
    } else {
        return (
            // A grey circle is used for future steps
            <ThemedAssessmentStepIndicator />
        );
    }
};
